import {
  DiscountQuantityWidgetTextReplacements,
  DiscountQuantityWidgetVariables,
} from "@intelligems/ig-types";

export const setDiscountQuantityVariables = (
  variables?: DiscountQuantityWidgetVariables
) => {
  const textReplacements: DiscountQuantityWidgetTextReplacements = {
    each: variables?.textReplacements?.each || "each",
    save: variables?.textReplacements?.save || "save",
    off: variables?.textReplacements?.off || "off",
    percent: variables?.textReplacements?.percent || "%",
  };

  return {
    buttons: variables?.buttons || [],
    textReplacements,
  };
};
